import { render, staticRenderFns } from "./eShop.vue?vue&type=template&id=2d01cba2&scoped=true"
import script from "./eShop.vue?vue&type=script&lang=js"
export * from "./eShop.vue?vue&type=script&lang=js"
import style0 from "./eShop.vue?vue&type=style&index=0&id=2d01cba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01cba2",
  null
  
)

export default component.exports